<template>
  <div class="relative">
    <label class="cursor-pointer flex items-center">
      <div
        class="w-5 h-5 rounded border flex justify-center items-center transition-all"
        :class="classList"
      >
        <transition name="transition-fade-pop">
          <vue-feather type="check"
                       v-show="checked"
                       class="w-3 h-3 text-white"></vue-feather>
        </transition>
      </div>
      <input
        type="checkbox"
        :name="name"
        :selected="checked"
        class="appearance-none"
        @change="handleChange"
      >
      <span
        class="ml-2"
        v-html="label"
      />
    </label>
  </div>
</template>

<script>
import VueFeather from 'vue-feather';

/**
 * Checkbox.vue
 */
export default {
  components: {
    VueFeather,
  },

  props: {
    label: {
      type: String,
      required: true,
    },

    name: {
      type: String,
      default: null,
    },

    checked: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {}
  },

  computed: {
    classList () {
      return [
        this.checked ? 'bg-blue-500 border-blue-500' : '',
      ]
    },
  },

  methods: {
    handleChange () {
      this.$emit('changeEvent', !this.checked)
    },
  },
}
</script>
